import { useAppDispatch, useAppSelector } from "../../stores/hooks/hooks.ts";
import { useParams } from "react-router";
import { useEffect } from "react";
import { RevSpinner } from "@revmatics/catalyst";
import { fetchBrandById } from "../../stores/thunks/brandThunk.tsx";
import { BrandDetailsPage } from "./BrandDetailsPage.tsx";
import { clearBrandById } from "../../stores/slice/brandSlice.tsx";
import { fetchCompanyById } from "../../stores/thunks/companyThunk.tsx";

export const BrandDetailsWrapperPage = () => {
  const dispatch = useAppDispatch();
  const { brandId } = useParams();
  const { companyId } = useParams();
  const companyById = useAppSelector((state) => state.company.companyById);
  const brandById = useAppSelector((state) => state.brand.brandById);
  const isLoading = useAppSelector((state) => state.brand.isLoadingById);

  useEffect(() => {
    if (brandId && (!brandById || brandById.id.toString() !== brandId)) {
      dispatch(fetchBrandById(brandId));
    }
  }, [dispatch, brandId, brandById]);

  useEffect(() => {
    if (
      companyId &&
      (!companyById || companyById.id.toString() !== companyId)
    ) {
      dispatch(fetchCompanyById(companyId));
    }
  }, [companyById, companyId, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearBrandById());
    };
  }, [dispatch]);

  if (isLoading) {
    return (
      <div className="h-full">
        <RevSpinner size="large" color="primary" centered />
      </div>
    );
  }

  if (brandById && !isLoading) {
    return <BrandDetailsPage brandById={brandById} />;
  }

  return <BrandDetailsPage brandById={null} />;
};
